<template>
  <ticket-search
    :delete-case="deleteCase"
    :download-document="downloadDocument"
    :get-case-documents="getUserCaseById"
    :get-comment-history="getCommentHistory"
    :get-status="getUserCaseStatus"
    :get-user-cases="getUserCases"
    :save-additional-info="saveAdditionalInfo"
    :status-id="statusId"
    @on-open-case="onOpenCaseHandler"
  />
</template>

<script>
import { TicketSearch } from 'support-tickets';
import {
  getUserCases as _getUserCases,
  getUserCaseStatus as _getUserCaseStatus,
  deleteCase as _deleteCase,
  saveAdditionalInfo as _saveAdditionalInfo,
  getCommentHistory as _getCommentHistory,
  getUserCaseById,
  downloadDocument,
} from '@/modules/helpdesk/api.js';

export default {
  name: 'CaseListMain',
  components: { TicketSearch },
  computed: {
    statusId() {
      return this.$route.params.status;
    },
  },
  methods: {
    downloadDocument,
    getUserCaseById,
    getUserCases(params, pageIndex, pageSize) {
      return _getUserCases(params, pageIndex, pageSize);
    },
    getUserCaseStatus() {
      return _getUserCaseStatus();
    },
    deleteCase(id) {
      return _deleteCase(id);
    },
    onOpenCaseHandler(item) {
      const { id } = item;

      this.$router.push({ name: 'DetailsTicket', params: { id } });
    },
    saveAdditionalInfo(formData) {
      return _saveAdditionalInfo(formData);
    },
    getCommentHistory(caseNumber) {
      return _getCommentHistory(caseNumber);
    },
  },
};
</script>
